/**
 *
 */
export enum OtherNodeType {
    GENERAL_LOAD = "general load",
    LIGHTING  = "lighting",
}